import { useEffect, useState } from 'react';
import { getGistContent } from '../services/gist';

export interface VerifiedListData {
  data: string[];
  loading: boolean;
}

export interface ListDto {
  address: string;
  name: string;
}

export const useVerifiedNFTsList = (): VerifiedListData => {
  const [loading, setLoading] = useState(true);
  const [loadedList, setLoadedList] = useState<string[]>([]);

  useEffect(() => {
    getGistContent(process.env.REACT_APP_VERIFIED_NFTS_LIST).then((response) => {
      const data = JSON.parse(response);
      if (data.length) {
        const addresses = data.map((entry: ListDto) => entry.address.toLowerCase());
        setLoadedList(addresses);
        setLoading(false);
      }
    });
  }, []);

  return {
    loading,
    data: loadedList,
  };
};
